<template>
    <div class="markdown-renderer prose prose-sm max-w-none" v-html="renderedHtml"></div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import MarkdownIt from 'markdown-it';

const props = defineProps<{
    source: string;
}>();

// Security boundary: html:false makes markdown-it escape raw HTML (inline <script>, on* handlers,
// <iframe>, <style>, etc. become inert text, not live nodes), and its default validateLink neutralizes
// javascript:, vbscript:, file: and non-image data: URLs in link & image destinations. The output is
// therefore safe for v-html without a separate sanitizer. Do NOT enable html or add a raw-HTML-emitting
// plugin without restoring sanitization — Terms are admin-authored and shown to others (stored-XSS risk).
const markdown = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
});

const renderedHtml = computed(() => markdown.render(props.source ?? ''));
</script>
